import {
    Boxes,
    Plus,
    Truck
} from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, getDateAndTime, handleDateChange, sanitizeInput } from '../CommonComponents/CustomHooks';
import { initializeFilterData } from '../CommonComponents/EnvConfig';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

// ── Initial Mock Dataset (Exact match with reference PDF) ────────────────────

export const AssignVehicle = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef({});
    // Mode: 'list' or 'create'
    const [assignModalOpen, setAssignModalOpen] = useState(false);
    // Checkbox selection for Assign
    const [selectedValue, setSelectedValue] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    // Search Filter States for Filter Card
    const initialFilterState = {
        pickupRequestDateFrom: getDateAndTime().date,
        pickupRequestDateTo: getDateAndTime().date,
        pickupRequestNo: '',
        //client: '',
        pickupLocation: '',
        pickupStatus: ''
    };
    const [searchFilters, setSearchFilters] = useState(initialFilterState);

    // Table state
    const [loading, setLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [singleAssignId, setSingleAssignId] = useState(null);
    const [assignForm, setAssignForm] = useState({
        vehicleType: '',
        vehicleNo: '',
        driver: '',
        fieldExecutive: ''
    });

    // ── Create Pickup Request Form State (Blank by default) ─

    const GetPickupPointP = DropDownData('GetPickupPoint', searchFilters.client)
    const GetVehicleType = DropDownData('GetVehicleType')
    const GetPickupStatus = DropDownData('GetPickupStatus')

    const [result, setResult] = useState([]);
    // Auto-focus on opening Create form or List form

    const handleCheck = (checked, id, index) => {
        setResult(prev => {
            if (!prev?.Data) return prev;
            const updatedData = prev.Data.map((item, idx) =>
                idx === index ? { ...item, checkStatus: checked } : item
            );
            return { ...prev, Data: updatedData };
        });

        if (checked) {
            setSelectedValue(prev => [...prev, id]);
        } else {
            setSelectedValue(prev => prev.filter(item => item !== id));
            setCheckAll(false);
        }
    };
    const handleAssign = (assignId, item) => {
        setSingleAssignId(assignId);
        setSelectedValue([]);      // bulk selection clear rakho, conflict na ho
        setCheckAll(false);
        setAssignForm({ vehicleType: '', vehicleNo: '', driver: '', fieldExecutive: '' });
        setAssignModalOpen(true);
    };
    const handleCheckAll = (checked) => {
        setCheckAll(checked);

        setResult(prev => {
            if (!prev?.Data) return prev;
            const updatedData = prev.Data.map(item => ({ ...item, checkStatus: checked }));
            return { ...prev, Data: updatedData };
        });

        if (checked) {
            const allIds = result?.Data?.map(item => item.Checkbox).filter(Boolean) || [];
            setSelectedValue(allIds);
        } else {
            setSelectedValue([]);
        }
    };
    const handleConfirmAssign = async (e) => {
        if (e?.preventDefault) e.preventDefault();   // 👈 safe check

        const pickupRequestNos = singleAssignId
            ? String(singleAssignId)
            : selectedValue.join(',');



        const requestData = {
            PickupRequestNo: pickupRequestNos,
            VehicleType: assignForm.vehicleType || '',
            VehicleNo: assignForm.vehicleNo || '',
            Driver: assignForm.driver || '',
            FieldExecutive: assignForm.fieldExecutive || ''
        };

        await dispatch(setSubLoading(true));
        let data = await ApiCall('/api/PickupRequest/AssignVehicle', requestData);
        await dispatch(setSubLoading(false));

        const status = data?.status || data?.Status;
        if (status === 'SUCCESS') {
            setAssignModalOpen(false);
            setAssignForm({ vehicleType: '', vehicleNo: '', driver: '', fieldExecutive: '' });
            setSelectedValue([]);
            setCheckAll(false);
            setSingleAssignId(null);
            getAccountMasterData();
            await NotificationSound(status, data?.message , data?.focus);
        }
        else {
            await NotificationSound(status, data?.message, data?.focus);
        }

    };

    const getAccountMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            ...searchFilters,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/PickupRequest/ShowAssignVehicle', GetData)
        if (data?.Data?.length) {
            data.Data = data.Data.map(item => ({
                ...item,
                checkStatus: item.checkStatus === true || item.checkStatus === 'true'
            }));
        }
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    };
    const handleChange1 = (event, value) => {
        setCurrentPageNo(value);
        getAccountMasterData(value, searchFilters);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };


    const handleClear = () => {
        setSearchFilters(initialFilterState);
        filterData.SearchText = ''
        setSortConfig({ SortColumn: null, SortOrder: null })
        inputrefs.current['txtPickupRequestNo'].focus();
    };

    useEffect(() => {
        getAccountMasterData()
        document.title = "Assign Vehicle";
        inputrefs.current['txtPickupRequestNo']?.focus();
    }, [sortConfig]);
    return (
        <div className="w-full space-y-3">
            {/* ── UNIFIED SINGLE CARD (Header + Filters) ── */}
            <div className="bg-white  border border-slate-200/90  rounded-xl p-3.5 sm:p-4 shadow-xs space-y-3">
                {/* 1. Header Section */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    {/* Left Side: Icon + Title */}
                    <div className="flex items-center gap-2">
                        <Boxes className="w-5 h-5 text-[var(--theme-color)]" />

                        <h2 className="text-base sm:text-lg font-bold text-slate-800 tracking-tight">
                            Assign Vehicle
                        </h2>

                    </div>

                    {/* Right Side: Action Buttons */}
                    {selectedValue?.length > 0 && (
                        <div className="flex items-center gap-2 self-end sm:self-auto">
                            <button
                                type="button"
                                onClick={() => setAssignModalOpen(true)}
                                className="flex items-center gap-1.5 ripple-btn px-3.5 py-1.5 bg-[var(--theme-color)] text-white rounded-lg font-bold shadow-xs uppercase tracking-wider text-[11px] hover:opacity-90 transition-all duration-200 cursor-pointer"
                            >

                                <Plus className="w-3.5 h-3.5" />
                                <span>{("Assign vehicle")}</span>
                            </button>
                        </div>
                    )}
                </div>

                {/* 2. Filter Inputs Section - 4 per row */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3.5 items-end">
                    {/* 1. From Pickup Date */}
                    <DateBox
                        label="From Pickup Request Date"
                        placeholder="DD-MMM-YYYY"
                        id="txtFromPickupDate"
                        inputrefs={inputrefs}
                        selected={searchFilters.pickupRequestDateFrom ? new Date(searchFilters.pickupRequestDateFrom) : null}
                        onChange={(date) => handleDateChange(date, setSearchFilters, searchFilters, 'pickupRequestDateFrom')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtFilterToPickupDate']?.focus();
                            }
                        }}
                    />

                    {/* 2. To Pickup Date */}
                    <DateBox
                        label="To Pickup Request Date"
                        placeholder="DD-MMM-YYYY"
                        id="txtFilterToPickupDate"
                        inputrefs={inputrefs}
                        selected={searchFilters.pickupRequestDateTo ? new Date(searchFilters.pickupRequestDateTo) : null}
                        onChange={(date) => handleDateChange(date, setSearchFilters, searchFilters, 'pickupRequestDateTo')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPickupRequestNo']?.focus();
                            }
                        }}
                    />

                    {/* 3. Pickup Request No */}
                    <InputBox
                        id="txtPickupRequestNo"
                        label="Pickup Request No"
                        placeholder="Enter Request No"
                        inputrefs={inputrefs}
                        value={searchFilters.pickupRequestNo}
                        onChange={(e) => setSearchFilters({ ...searchFilters, pickupRequestNo: sanitizeInput(e.target.value) })}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPickupLocation']?.focus();
                            }
                        }}
                        divclassname="w-full"
                    />

                    {/* 4. Client Autocomplete */}
                    {/*<AutoCompleteBoxNew*/}
                    {/*    id="txtFilterClient"*/}
                    {/*    label="Client"*/}
                    {/*    placeholder="Select Client"*/}
                    {/*    inputrefs={inputrefs}*/}
                    {/*    autocompleteType="GetClientMaster"*/}
                    {/*    value={searchFilters.client || ''}*/}
                    {/*    onChange={async (event, newInputValue) => {*/}
                    {/*        newInputValue = newInputValue || '';*/}
                    {/*        if (event.type !== 'keydown') {*/}
                    {/*            setSearchFilters({ ...searchFilters, client: newInputValue });*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*    onKeyDown={(e) => {*/}
                    {/*        if (e.key === 'Enter') {*/}
                    {/*            e.preventDefault();*/}
                    {/*            inputrefs.current['txtPickupLocation']?.focus();*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*    divclassname="w-full"*/}
                    {/*/>*/}

                    {/* 5. Location SelectBox */}
                    <SelectInputBox
                        id="txtPickupLocation"
                        label="Pickup Location"
                        value={searchFilters.pickupLocation}
                        onChange={(e) => setSearchFilters({ ...searchFilters, pickupLocation: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtStatus']?.focus();
                            }
                        }}
                        divclassname="w-full"
                    >
                        <option value="">--Please Select--</option>
                        {GetPickupPointP?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}

                    </SelectInputBox>

                    {/* 6. Status SelectBox */}
                    <SelectInputBox
                        id="txtStatus"
                        label="Status"
                        value={searchFilters.pickupStatus}
                        onChange={(e) => setSearchFilters({ ...searchFilters, pickupStatus: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnFilter']?.focus();
                            }
                        }}
                        divclassname="w-full"
                    >
                        <option value="">--Please Select--</option>
                        {GetPickupStatus?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}

                    </SelectInputBox>
                </div>

                {/* 3. Search, Reset & Export Buttons */}
                <div className="flex items-center justify-start gap-2 pt-1">
                    <FormButton
                        id="btnFilter"
                        inputrefs={inputrefs}
                        search={true}
                        Reset={true}
                        handleClear={handleClear}
                        save={false}
                        Export={true}
                        extraclassname=""
                        handleSearch={getAccountMasterData}
                        // handleClear={handleReset}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            await handleDownloadExcel(`/api/PickupRequest/ShowAssignVehicle`, filterData, 'Assign Vehicle')
                            await dispatch(setSubLoading(false))
                        }}
                    />
                </div>
            </div>

            {/* ── Table Card ── */}
            <div className='mt-3'>
                <Table

                    PageName={'AssignVehicle'}
                    loading={loading}
                    handleFilter={() => {
                        getAccountMasterData(1, searchFilters)
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    Filter={false}
                    onlyFilterPage={true}
                    tableData={result}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                    handleCheck={handleCheck}
                    handleCheckAll={handleCheckAll}
                    checkAll={checkAll}
                    handleAssign={handleAssign}

                />
            </div>


            {assignModalOpen && (
                <div className="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-white  border border-slate-200  rounded-2xl max-w-xl w-full p-5 sm:p-6 shadow-2xl space-y-4 animate-in fade-in zoom-in-95 duration-150">

                        <div className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                                {/* 1. Vehicle Type (SelectInputBox) */}
                                <SelectInputBox
                                    id="txtVehicleType"
                                    label="Vehicle Type"
                                    required
                                    inputrefs={inputrefs}
                                    value={assignForm.vehicleType || ''}
                                    onChange={(e) => setAssignForm({ ...assignForm, vehicleType: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['txtVehicleNo']?.focus();
                                        }
                                    }}
                                >
                                    <option value=''> -Please Select - </option>
                                    {GetVehicleType?.data?.dropDownData?.map((item, index) => (
                                        <option key={item.valuePart + index} value={item.valuePart}>
                                            {(item.textPart)}
                                        </option>
                                    ))}

                                </SelectInputBox>

                                {/* 2. Vehicle No (AutoCompleteBoxNew) */}
                                <AutoCompleteBoxNew
                                    id="txtVehicleNo"
                                    label="Vehicle No"
                                    placeholder="Search vehicle number..."
                                    required
                                    inputrefs={inputrefs}
                                    autocompleteType="GetVehicleNo"
                                    value={assignForm.vehicleNo || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setAssignForm({ ...assignForm, vehicleNo: newInputValue });
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['txtDriver']?.focus();
                                        }
                                    }}
                                />
                                <AutoCompleteBoxNew
                                    id="txtDriver"
                                    label="Driver"
                                    required
                                    placeholder="Search driver name..."
                                    inputrefs={inputrefs}
                                    autocompleteType="GetDrivers"
                                    value={assignForm.driver || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setAssignForm({ ...assignForm, driver: newInputValue });
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['txtAssignFieldExecutive'].focus();
                                        }
                                    }}
                                />

                                {/* Field Executive - Autocomplete */}
                                <AutoCompleteBoxNew
                                    id="txtAssignFieldExecutive"
                                    label="Field Executive"
                                    required
                                    placeholder="Search field executive..."
                                    inputrefs={inputrefs}
                                    autocompleteType="GetFieldExecutive"
                                    value={assignForm.fieldExecutive || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setAssignForm({ ...assignForm, fieldExecutive: newInputValue });
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['btnSub']?.focus();
                                        }
                                    }}
                                />
                            </div>

                            {/* Footer Action Buttons */}
                            <div className="flex items-center justify-end gap-2.5 pt-3 border-t border-slate-100 ">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setAssignModalOpen(false);
                                        setSingleAssignId(null);
                                    }}
                                    className="px-4 py-2 rounded-lg border border-slate-300   hover:bg-slate-50  text-slate-700 text-xs font-semibold cursor-pointer transition-colors"
                                >
                                    {("Cancel")}
                                </button>
                                <button
                                    id="btnSub"
                                    ref={(el) => {
                                        if (inputrefs.current) inputrefs.current['btnSub'] = el;
                                    }}
                                    type="button"
                                    onClick={handleConfirmAssign}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            handleConfirmAssign(e);
                                        }
                                    }}
                                    className="px-5 py-2 rounded-lg bg-[var(--theme-color)] text-white text-xs font-bold shadow-xs hover:opacity-90 transition-all flex items-center gap-1.5 cursor-pointer"
                                >
                                    <Truck className="w-3.5 h-3.5" />
                                    <span>{("Confirm & Assign")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssignVehicle;
